// SchoolRating.jsx
import { MdStar, MdStarBorder } from "react-icons/md";

const getStarCount = (schoolLevel) => {
  switch (schoolLevel) {
    case "Higher":
      return 5;
    case "Average":
      return 4;
    case "Lower":
      return 3;
    default:
      return 0;
  }
};

const SchoolRating = ({ schoolLevel }) => {
  const totalStars = 5;
  const filledStars = getStarCount(schoolLevel);
  const emptyStars = totalStars - filledStars;

  return (
    <>
      {[...Array(filledStars)].map((_, index) => (
        <MdStar key={`filled-${index}`} className="stars" />
      ))}
      {[...Array(emptyStars)].map((_, index) => (
        <MdStarBorder key={`empty-${index}`} className="stars" />
      ))}
    </>
  );
};

export default SchoolRating;